<template>
  <div>
    <Levo />
    <router-view />
    <!-- <GameSplashScreenOwner />-->
    <FinalScreen v-if="isFinalScreen" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { splashScreenEnum } from "../store/game/store";
import Levo from "@/components/gameManager/levo/levo.vue";
import FinalScreen from "../components/game/FinalScreen";
//import GameSplashScreenOwner from "@/components/gameManager/GameSplashScreenOwner.vue";

export default {
  name: "GameManager",
  components: {
    FinalScreen,
    Levo,
    //GameSplashScreenOwner,
  },
  computed: {
    ...mapGetters(["splashScreenState"]),
    isFinalScreen() {
      return this.splashScreenState === splashScreenEnum.GAME_END_RESULT;
    },
  },
  async mounted() {
    await this.$store.dispatch("fetchOwnGames");
    await this.$store.dispatch("fetchOwnActiveGames");
    await this.$store.dispatch("fetchOwnArchivedGames");
    const joinedGame = this.$store.getters.joinedGame;
    if (joinedGame && !joinedGame.endedTime) {
      await this.$store.dispatch("setOwnerCurrentGameId", joinedGame);

      const ownerCurrentGame = this.$store.getters.ownerCurrentGame;
      if (ownerCurrentGame) {
        if (ownerCurrentGame.startedTime) {
          await this.$router.push({ name: "GameManager.game.overview" });
        } else {
          await this.$router.push({ name: "GameManager.game.lobby" });
        }
      }
    }
  },
};
</script>
